import { Link } from "react-router-dom";
import PublicNavbar from "./PublicNavbar";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <PublicNavbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400">
      <div className="max-w-6xl mx-auto px-5 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">

          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-7 h-7 bg-orange-500 rounded-lg flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-white" stroke="currentColor" strokeWidth={2.2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                </svg>
              </div>
              <span
                className="text-lg font-bold text-white"
                style={{ fontFamily: "'Sora', sans-serif" }}
              >
                Tuma<span className="text-orange-400">Track</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              The delivery management platform built for Kenyan businesses.
              Track every order, every driver, in real time.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <p className="text-white text-sm font-semibold mb-4">Product</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
            </ul>
          </div>

          {/* Account Links */}
          <div>
            <p className="text-white text-sm font-semibold mb-4">Account</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/login" className="hover:text-white transition-colors">Login</Link></li>
              <li><Link to="/register" className="hover:text-white transition-colors">Register</Link></li>
            </ul>
          </div>
        </div>

        <div>
        <p className="text-white text-sm font-semibold mb-4">Support</p>
        <ul className="space-y-2 text-sm">
          <li>
            <a href="mailto:hello@tumatrack.co.ke" className="hover:text-white transition-colors">
              hello@tumatrack.co.ke
            </a>
          </li>
          <li>
            <a href="mailto:support@tumatrack.co.ke" className="hover:text-white transition-colors">
              support@tumatrack.co.ke
            </a>
          </li>
          <li>
            <a href="https://wa.me/254769177634" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
              WhatsApp Support
            </a>
          </li>
        </ul>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs">© {new Date().getFullYear()} TumaTrack. Built for Kenya 🇰🇪</p>
          <p className="text-xs">
            Payments via <span className="text-green-400 font-medium">M-Pesa</span>
          </p>
        </div>
      </div>
    </footer>
  );
}